import React from "react";
import { AlertTriangle, Phone, CheckCircle, X } from "lucide-react";
import { formatDate } from "../../utils/dateFormat";

/**
 * PendingPaymentsPanel - Displays pending karaoke bookings awaiting payment verification
 */
const PendingPaymentsPanel = ({ 
  pendingBookings, 
  onVerifyPayment, 
  onCancelBooking,
  canCancelBooking,
  facilityType = 'karaoke' // 'karaoke' or 'bbq'
}) => {
  const isKaraoke = facilityType === 'karaoke';
  
  return (
    <div className="brutal-card">
      <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
        <AlertTriangle className="text-red-500" /> 
        Pending {isKaraoke ? <span className="notranslate" translate="no">Karaoke</span> : 'BBQ'} Payments
      </h3>
      
      {pendingBookings.length === 0 ? (
        <p className="text-gray-500 text-center py-8">No pending payments</p>
      ) : (
        <div className="space-y-4">
          {pendingBookings.map(booking => (
            <div key={booking.booking_id} className="border-2 border-red-300 bg-red-50 p-4 rounded">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="font-mono font-bold text-purple-600 notranslate" translate="no">
                      {booking.booking_code}
                    </span>
                    <span className="px-2 py-0.5 bg-amber-200 text-amber-800 text-xs font-bold rounded">
                      PENDING
                    </span>
                  </div>
                  <p className="font-bold notranslate" translate="no">
                    {isKaraoke ? booking.member_name : booking.name}
                  </p>
                  <p className="text-sm text-gray-600 notranslate" translate="no">
                    {isKaraoke ? booking.member_email : booking.email}
                  </p>
                  <p className="text-sm font-mono mt-1">
                    {formatDate(booking.date)} • {booking.slot_type === 'afternoon' ? '1PM-5PM' : '6PM-10PM'}
                  </p>
                  <p className="text-sm text-purple-700">${booking.price}</p>
                </div>
                
                <div className="flex flex-col gap-2">
                  {(isKaraoke ? booking.member_phone : booking.mobile) ? (
                    <a 
                      href={`tel:${isKaraoke ? booking.member_phone : booking.mobile}`}
                      className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white font-bold text-sm border-2 border-black hover:bg-blue-600"
                    >
                      <Phone size={16} /> 
                      <span className="notranslate" translate="no">
                        {isKaraoke ? booking.member_phone : booking.mobile}
                      </span>
                    </a>
                  ) : (
                    <div className="flex items-center gap-2 px-4 py-2 bg-gray-300 text-gray-600 font-bold text-sm border-2 border-black cursor-not-allowed">
                      <Phone size={16} /> No Phone
                    </div>
                  )}
                  <button
                    onClick={() => onVerifyPayment(booking.booking_id)}
                    className="flex items-center justify-center gap-2 px-4 py-2 bg-green-500 text-white font-bold text-sm border-2 border-black hover:bg-green-600"
                  >
                    <CheckCircle size={16} /> VERIFY PAYMENT
                  </button>
                  {canCancelBooking && canCancelBooking(booking) && (
                    <button
                      onClick={() => onCancelBooking(booking)}
                      className="flex items-center justify-center gap-2 px-4 py-2 bg-red-500 text-white font-bold text-sm border-2 border-black hover:bg-red-600"
                    >
                      <X size={16} /> CANCEL
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PendingPaymentsPanel;
